/**
 * Customer column: external link to customer profile with click tracking separate from row navigation.
 */
import type { MouseEvent } from "react";
import { observer } from "mobx-react";
import FontBody2 from "../../../../../../../../../components/fonts/font-body2/font-body2";
import { FontProps, FONT_COLOR } from "../../../../../../../../../components/fonts/font-props";
import {
    MANAGE_RETURNS_DESIGN_VERSION,
    trackManageReturnsListEvent,
} from "../../../../../../../utils/manage-returns-list-mixpanel";
import ExternalLink from "../../../../../../../components/external-link/external-link";
import RmaListItemStore from "../../../../../../../rma-list-page/stores/rma-item-store";
import "./table-column-customer.scss";

/** Plain navy body text for customer names; ignores link-default accent/underline from ExternalLink. */
const CustomerColumnFont: React.FC<FontProps> = ({ children }) => (
    <FontBody2 color={FONT_COLOR.PRIMARY2}>{children}</FontBody2>
);

export interface ITableColumnCustomerProps {
    rma: RmaListItemStore;
}

const TableColumnCustomer: React.FC<ITableColumnCustomerProps> = observer(({ rma }) => {
    const onCustomerClick = (e: MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        trackManageReturnsListEvent("d&_customer", MANAGE_RETURNS_DESIGN_VERSION.V2);
    };

    if (!rma.showCustomerLink) {
        return <div className="table-column-customer" />;
    }

    return (
        <div className="table-column-customer" onClick={(e) => onCustomerClick(e)}>
            <ExternalLink
                label={rma.customerDisplayLabel}
                url={rma.customerUrl}
                Font={CustomerColumnFont}
            />
        </div>
    );
});

export default TableColumnCustomer;
